import FinanceIqFallbackAlert from './FinanceIqFallbackAlert';
import KpiSpotlightCard from './KpiSpotlightCard';
import { useKpiSpotlight } from './useKpiSpotlight';

export interface KpiSpotlightBannerContentProps {
  makerOrganizationUuid: string;
  currency: string;
  buyerName: string;
}

const KpiSpotlightBannerContent = ({ makerOrganizationUuid, currency, buyerName }: KpiSpotlightBannerContentProps) => {
  const { data } = useKpiSpotlight({ makerOrganizationUuid, currency });
  const { spotlight } = data;

  if (!spotlight) {
    return <FinanceIqFallbackAlert />;
  }

  return (
    <KpiSpotlightCard
      spotlight={spotlight}
      makerOrganizationUuid={makerOrganizationUuid}
      currency={currency}
      buyerName={buyerName}
    />
  );
};

export default KpiSpotlightBannerContent;
